import React, { Component } from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects, Types} from "components";

import API from "@beardeddevops/react.api";
import SendToKioskObject from "./SendToKiosk";
import {Button, ButtonGroup, Label, Modal, ModalHeader, ModalBody} from "reactstrap";
import TransactionObject from "components/TransactionObject";
import ObjectOverride from "components/ObjectOverride";


class GunbrokerConfig extends ObjectOverride {
	constructor(props) {
		super(props, Types.Products._name);
		this.state = {
			loading: false,
			fixed_count: 0,
			fixed_count_error: "",
			listing_duration: 0,
			listing_duration_error: "",
			shipping_profile: "",
			shipping_profile_error: "",
			shippingProfiles: [],
			gunbroker_category: '',
			gunbroker_title: '',
			gunbroker_condition: '',
			gunbroker_description: '',
			check: false,
			check_error: "",
			visa_mastercard: false,
			visa_mastercard_error: "",
			cod: false,
			cod_error: "",
			escrow: false,
			escrow_error: "",
			amex: false,
			amex_error: "",
			paypal: false,
			paypal_error: "",
			discover: false,
			discover_error: "",
			certified_check: false,
			certified_check_error: "",
			usps_money_order: false,
			usps_money_order_error: "",
			money_order: false,
			money_order_error: "",
			financing: false,
			financing_error: "",
			listing_durations: [
				{ pkey: '30', name: 'Thirty days (Fixed price items only)' },
				{ pkey: '60', name: 'Sixty days (Fixed price items only)' },
				{ pkey: '90', name: 'Ninety days (Fixed price items only)' },
			]

		};
		this.loadShippingProfiles().then();
		// this.loadCategories().then();
	}

	componentDidMount() {
		super.componentDidMount();
		if(this.props.product) {
			this.setState({
				...this.props.product,
				'postal_code': this.props.postal_code,
				fixed_listing: true,
				use_shipping_profile: true,
				who_pays_for_shipping: true
			})
		}
	}



	async loadShippingProfiles() {
		let spModel = new API.BuildClass(Types.Products._name, 'GET_GUNBROKER_SHIPPING_PROFILES');
		let shippingProfiles = await spModel.submit(null, 'GET_GUNBROKER_SHIPPING_PROFILES');

		this.setState({shippingProfiles: shippingProfiles['shipping_profiles']});
	}


	// async loadCategories() {
	// 	let cModel = new API.BuildClass(Types.Products._name, 'GET_GUNBROKER_CATEGORIES');
	// 	let categories = await cModel.submit(null, 'GET_GUNBROKER_CATEGORIES');
	// 	console.log('categories', categories);
	// }

	handleCheckboxChange = (category, key) => {
		this.setState({
			[category]: {
				...this.state[category],
				[key]: !this.state[category][key]
			}
		});
	};

	handleTextFieldPropertyUpdate = (property, value) => {
		this.setState({
			[property]: value,
			[property + '_error']: '',
		});

		let object_property = this.model.properties[property] || null;
		// noinspection JSUnresolvedVariable
		let ux_validate = object_property ? object_property.ux_validation : false;
		if (ux_validate) {
			this.model.handleUXValidation(this, this.update, function (response) {
				console.log('WARNING : ' + response);
			});
		}
	};

	async handleSubmit() {
		this.setState({loading: true})
		let aModel = new API.BuildClass(Types.Products._name, 'PUT_GUNBROKER_PRODUCT');
		aModel.object = this.state;
		aModel.object.p_id = this.state._id;
		// let result = await aModel.submit(this, 'PUT_GUNBROKER_PRODUCT').then(() => this.setState({loading: false}));
		try {
			await aModel.submit(this, 'PUT_GUNBROKER_PRODUCT')
			this.setState({loading: false})
			this.props.history.push('/');
			this.props.history.push('products/#foreign');
		} catch (e) {
			this.setState({loading: false})
		}


	}

	setListingDurationsFixed = async () => {
		if(this.state.fixed_listing === true) {
			this.setState({listing_durations: [
					{ pkey: '30', name: 'Thirty days (Fixed price items only)' },
					{ pkey: '60', name: 'Sixty days (Fixed price items only)' },
					{ pkey: '90', name: 'Ninety days (Fixed price items only)' }
				]
			})
		}
		else {
			this.setState({listing_durations: [
					{ pkey: '4', name: 'Four days' },
					{ pkey: '5', name: 'Five days' },
					{ pkey: '6', name: 'Six days' },
					{ pkey: '7', name: 'Seven days' },
					{ pkey: '8', name: 'Eight days' },
					{ pkey: '9', name: 'Nine days' },
					{ pkey: '10', name: 'Ten days' },
					{ pkey: '11', name: 'Eleven days' },
					{ pkey: '12', name: 'Twelve days' },
					{ pkey: '13', name: 'Thirteen days' },
					{ pkey: '14', name: 'Fourteen days' }
				]
			})
		}
	}

	handleFixedListingUpdate = async (property, value) => {
		await this.handleTextFieldPropertyUpdate(property, value);
		await this.setListingDurationsFixed();
	}




	render() {
		const object = this.state;
		/** @type {Product_Properties} properties */
		let properties = this.model.properties;

		return (

			<div>
				<fieldset>
					<div>
						<h4 className="section-title">Listing Options</h4>
						<div className={'col-1'}>
							<div className={'text-right'}>
								<span className="input-label">Fixed Listing Price</span>
							</div>
						</div>
						<div className={'col-2'}>
							<Framework.Elements.ButtonSwitch
								property={properties.fixed_listing}
								value={object.fixed_listing}
								error={object.fixed_listing_error}
								update={(property, value) => this.handleFixedListingUpdate(property, value)}
								name={"check"}
							/>
						</div>

						{this.state.fixed_listing ?
							<div className={"col-12"} style={{marginTop: '20px'}}>
								<Framework.Elements.TextField
									label={"Listing Price"}
									property={this.model.properties.price_list}
									value={object.price_list}
									error={object.price_list_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							:
							<div className={"row"}>
								<div className={"col-4"} style={{marginTop: '20px'}}>
									<Framework.Elements.TextField
										label={"Starting Bid"}
										property={this.model.properties.auction_price}
										value={object.auction_price}
										error={object.auction_price_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className={"col-4"} style={{marginTop: '20px'}}>
									<Framework.Elements.TextField
										label={"Buy Now Price"}
										property={this.model.properties.buy_now_price}
										value={object.buy_now_price}
										error={object.buy_now_price_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className={"col-4"} style={{marginTop: '20px'}}>
									<Framework.Elements.TextField
										label={"Reserve Price"}
										property={this.model.properties.reserve_price}
										value={object.reserve_price}
										error={object.reserve_price_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						}

						<h4 className="section-title" style={{marginTop: '20px'}}>GunBroker Listing Information</h4>
						<div className={"row"}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Title"}
									property={this.model.properties.gunbroker_title}
									value={object.gunbroker_title}
									error={object.gunbroker_title_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Serial Number"}
									property={this.model.properties.serial_number}
									value={object.serial_number}
									error={object.serial_number_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Postal Code"}
									property={this.model.properties.postal_code}
									value={object.postal_code}
									error={object.postal_code_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"col-6"}>
								<Framework.Elements.TextField
									label={"Quantity"}
									property={this.model.properties.gunbroker_quantity}
									value={object.gunbroker_quantity}
									error={object.gunbroker_quantity_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>

						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.Select
									label={"Listing Duration"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={this.state.listing_durations}
									property={this.model.properties.listing_duration}
									value={object.listing_duration}
									error={object.listing_duration_error}
									text={'name'}
									nullable={true}
									limit={null}
								/>
							</div>


						</div>
						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-6"}>
								<Framework.Elements.Select
									label={"Category Selection"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: '2325', name: 'Revolvers'},
										{pkey: '3026', name: 'Semi Auto Pistols'},
										{pkey: '3101', name: 'Single Shot Pistols'},
										{pkey: '3027', name: 'Other Pistols'},
										{pkey: '3022', name: 'Bolt Action Rifles'},
										{pkey: '3023', name: 'Lever Action Rifles'},
										{pkey: '3102', name: 'Pump Action Rifles'},
										{pkey: '3024', name: 'Semi Auto Rifles'},
										{pkey: '3011', name: 'Single Shot Rifles'},
										{pkey: '3025', name: 'Other Rifles'},
										{pkey: '3112', name: 'Bolt Action Shotguns'},
										{pkey: '3113', name: 'Lever Action Shotguns'},
										{pkey: '3103', name: 'Over Under Shotguns'},
										{pkey: '3106', name: 'Pump Action Shotguns'},
										{pkey: '3105', name: 'Semi Auto Shotguns'},
										{pkey: '3104', name: 'Side By Side Shotguns'},
										{pkey: '3107', name: 'Single Shot Shotguns'},
										{pkey: '3108', name: 'Other Shotguns'},
										{pkey: '4032', name: 'Any Other Weapon (AOW)'},
										{pkey: '3098', name: 'Class 3 Parts & Accessories'},
										{pkey: '3100', name: 'Destructive Devices'},
										{pkey: '2326', name: 'Machine Guns'},
										{pkey: '4031', name: 'Short Barrel Rifles (SBR)'},
										{pkey: '3099', name: 'Silencers & Suppressed Firearms'},

									]}
									property={this.model.properties.gunbroker_category}
									value={object.gunbroker_category}
									error={object.gunbroker_category_error}
									text={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
							<div className="col-6">
								<Framework.Elements.Select
									label={"Condition"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: '1', name: 'Factory new'},
										{pkey: '2', name: 'New Old Stock'},
										{pkey: '3', name: 'Used'},
									]}
									property={this.model.properties.gunbroker_condition}
									value={object.gunbroker_condition}
									error={object.gunbroker_condition_error}
									text={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
						</div>
						<div className={"row"} style={{marginTop: "20px"}}>
							<div className={"col-12"}>
								<Framework.Elements.TextField
									label={"Description"}
									property={this.model.properties.gunbroker_description}
									value={object.gunbroker_description}
									error={object.gunbroker_description_error}
									multiline={4}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>


						<h4 style={{marginTop: '20px'}} className="section-title">Shipping Options</h4>
						<div className={"row"}>
							<div className={'col-1'}>
								<div className={'text-right'}>
									<span className="input-label">Use Shipping Profile</span>
								</div>
							</div>

							<div className={'col-2'} style={{marginLeft: '40px'}}>
								<Framework.Elements.ButtonSwitch
									property={properties.use_shipping_profile}
									value={object.use_shipping_profile}
									name={"Shipping Profile"}
									update={this.handleTextFieldPropertyUpdate}

								/>
							</div>

						</div>
						<div style={{
							borderBottom: '1px dashed #ccc',
							margin: '20px 0'
						}}></div>
						{this.state.use_shipping_profile ?
							<div className={"col-6"} style={{marginTop: '20px'}}>
								<Framework.Elements.Select
									style={{paddingTop: "20px"}}
									label={"Shipping Profile Selection"}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									objects={this.state.shippingProfiles}
									property={this.model.properties.shipping_profile}
									value={object.shipping_profile}
									error={object.shipping_profile_error}
									text={'shippingProfileID&name'}
									nullable={true}
									limit={null}
								/>
							</div>
							:

							<div>
								<div className={"row"}>
									<div className={'col-3'} style={{marginTop: '20px'}}>
										<Label for={'shipping-Group'}>Buyer Pays For Shipping?</Label>
										<Framework.Elements.ButtonSwitch
											id={'Shipping-Group'}
											property={properties.who_pays_for_shipping}
											value={object.who_pays_for_shipping}
											error={object.who_pays_for_shipping_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>

									<div className={'col-6'} style={{marginTop: '20px'}}>
										<Framework.Elements.TextField
											label={"Item Weight"}
											property={this.model.properties.item_weight_gunbroker}
											value={object.item_weight_gunbroker}
											error={object.item_weight_gunbroker_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className={'col-3'} style={{marginTop: '20px'}}>
										<Label for={'pounds-Group'}>Pounds or KG</Label>
										<Framework.Elements.ButtonSwitch
											id={'pounds-Group'}
											labelTrue={'Pounds'}
											labelFalse={'KG'}
											property={properties.item_weight_pounds}
											value={object.item_weight_pounds}
											error={object.item_weight_pounds_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>


								</div>
								<div style={{
									borderBottom: '1px dashed #ccc',
									margin: '20px 0'
								}}></div>


								<div style={{display: 'flex', gap: '30px', flexDirection: 'column'}}>
									<div className={"row"} style={{marginTop: '21px'}}>
										<div className={'col-3'}>
											<Label for={'Overnight-Group'}>Overnight</Label>
											<Framework.Elements.ButtonSwitch
												id={'Overnight-Group'}
												label={"Overnight"}
												property={properties.overnight}
												value={object.overnight}
												error={object.overnight_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>

										<div className={'col-3'}>
											<Label for={'second_day-Group'}>2nd Day</Label>
											<Framework.Elements.ButtonSwitch
												id={'second_day-Group'}
												property={properties.second_day}
												value={object.second_day}
												error={object.second_day_error}
												update={this.handleTextFieldPropertyUpdate}
												name={"Visa Mastercard"}
											/>
										</div>

										<div className={'col-3'}>
											<Label for={'third_day-Group'}>3rd Day</Label>
											<Framework.Elements.ButtonSwitch
												id={'third_day-Group'}
												property={properties.third_day}
												value={object.third_day}
												error={object.third_day_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>

										<div className={'col-3'}>
											<Label for={'ground-Group'}>Ground</Label>
											<Framework.Elements.ButtonSwitch
												id={'ground-Group'}
												property={properties.ground}
												value={object.ground}
												error={object.ground_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>

									<div className={"row"}>
										<div className={'col-3'}>
											<Label for={'usps_priority_mail-Group'}>USPS Priority Mail</Label>
											<Framework.Elements.ButtonSwitch
												id={'usps_priority_mail-Group'}
												property={properties.usps_priority_mail}
												value={object.usps_priority_mail}
												error={object.usps_priority_mail_error}
												update={this.handleTextFieldPropertyUpdate}
												label={"USPS Priority Mail"}
											/>
										</div>

										<div className={'col-3'}>
											<Label for={'usps_first_class-Group'}>USPS First Class</Label>
											<Framework.Elements.ButtonSwitch
												id={'usps_first_class-Group'}
												property={properties.usps_first_class}
												value={object.usps_first_class}
												error={object.usps_first_class_error}
												update={this.handleTextFieldPropertyUpdate}
												name={"Visa Mastercard"}
											/>
										</div>

										<div className={'col-3'}>
											<Label for={'other-Group'}>Other</Label>
											<Framework.Elements.ButtonSwitch
												id={'other-Group'}
												property={properties.other}
												value={object.other}
												error={object.other_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>

										<div className={'col-3'}>
											<Label for={'alaska_hawaii_us_territory-Group'}>Alaska/Hawaii/US Territory</Label>
											<Framework.Elements.ButtonSwitch
												id={'alaska_hawaii_us_territory-Group'}
												property={properties.alaska_hawaii_us_territory}
												value={object.alaska_hawaii_us_territory}
												error={object.alaska_hawaii_us_territory_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
							</div>
						}


						<h4 style={{marginTop: "20px"}} className="section-title">Payment Options</h4>
						<div className={"row"}>

							<div className={'col-3'}>
								<Label for={'amex-Group'}>Amex</Label>
								<Framework.Elements.ButtonSwitch
									id={'amex-Group'}
									property={properties.amex}
									value={object.amex}
									error={object.amex_error}
									update={this.handleTextFieldPropertyUpdate}
									name={"check"}
								/>
							</div>
								<div className={'col-3'}>
									<Label for={'paypal-Group'}>Paypal</Label>
									<Framework.Elements.ButtonSwitch
										id={'paypal-Group'}
										property={properties.paypal}
										value={object.paypal}
										error={object.paypal_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

								<div className={'col-3'}>
									<Label for={'cod-Group'}>COD</Label>
									<Framework.Elements.ButtonSwitch
										id={'cod-Group'}
										property={properties.cod}
										value={object.cod}
										error={object.cod_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

								<div className={'col-3'}>
									<Label for={'escrow-Group'}>Escrow</Label>
									<Framework.Elements.ButtonSwitch
										id={'escrow-Group'}
										property={properties.escrow}
										value={object.escrow}
										error={object.escrow_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>

							<div className={'row'} style={{marginTop: '20px'}}>
								<div className={'col-3'}>
									<Label for={'check-Group'}>Check</Label>
									<Framework.Elements.ButtonSwitch
										id={'check-Group'}
										property={properties.check}
										value={object.check}
										error={object.check_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

								<div className={'col-3'}>
									<Label for={'visa-Group'}>Visa</Label>
									<Framework.Elements.ButtonSwitch
										id={'visa-Group'}
										property={properties.visa_mastercard}
										value={object.visa_mastercard}
										error={object.visa_mastercard_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

								<div className={'col-3'}>
									<Label for={'discover-Group'}>Discover</Label>
									<Framework.Elements.ButtonSwitch
										id={'discover-Group'}
										property={properties.discover}
										value={object.discover}
										error={object.discover_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

								<div className={'col-3'}>
									<Label for={'financing-Group'}>Financing</Label>
									<Framework.Elements.ButtonSwitch
										id={'financing-Group'}
										property={properties.financing}
										value={object.financing}
										error={object.financing_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>

							<div className={'row'} style={{marginTop: '20px'}}>
								<div className={'col-3'}>
									<Label for={'usps-money-order-Group'}>USPS Money Order</Label>
									<Framework.Elements.ButtonSwitch
										id={'usps-money-order-Group'}
										property={properties.usps_money_order}
										value={object.usps_money_order}
										error={object.usps_money_order}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

								<div className={'col-3'}>
									<Label for={'money-order-Group'}>Money Order</Label>
									<Framework.Elements.ButtonSwitch
										id={'money-order-Group'}
										property={properties.money_order}
										value={object.money_order}
										error={object.money_order_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

								<div className={'col-3'}>
									<Label for={'certified-check-Group'}>Certified Check</Label>
									<Framework.Elements.ButtonSwitch
										id={'certified-check-Group'}
										property={properties.certified_check}
										value={object.certified_check}
										error={object.certified_check_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
						</div>


						<h4 style={{marginTop: "20px"}} className="section-title">Relist Options
						</h4>
						<ButtonGroup
							// style={{marginLeft: "20px"}}
							className={"col-12"}>
							<Button color={"danger"}
							        outline={this.state.do_not_relist === true}
							        onClick={() => {
								        this.setState({
									        'do_not_relist': true,
									        'relist_until_sold': false,
									        'relist_fixed_count': false,
									        'relist_fixed_price': false
								        })
							        }}
							        active={this.state.do_not_relist === true}>Do Not Relist</Button>

							<Button color={"primary"}
							        outline={this.state.relist_until_sold === true}
								// style={{marginLeft: "10px"}}
								    onClick={() => {
									    this.setState({
										    'do_not_relist': false,
										    'relist_until_sold': true,
										    'relist_fixed_count': false,
										    'relist_fixed_price': false
									    })
								    }}
								    active={this.state.relist_until_sold === true}>Relist Until Sold</Button>
						</ButtonGroup>
					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>
			</div>
		);
	}
}


export default Framework.Components.withRootState(GunbrokerConfig);
